export default __webpack_public_path__ + "static/AssertioSpecialtyPharmaceuticals-3c243a05c7981024a743a4a9f0e1daa4.png";